export const filterObjectsBySearchString = ({objects, searchString}) => {
  return objects.filter((obj) => {
    return Object.values(obj).some((value) =>
      String(value).toLowerCase().includes(searchString.toLowerCase()),
    );
  });
};
